import axios from 'axios';

const luckeyWebSiteInstance = axios.create({
  timeout: 30000,
  baseURL: 'https://sofialocks.com/',
});


export function fetchWhatsNewArticles(languagePrexif, params) {
  const restParams = {
    params,
  };
  return luckeyWebSiteInstance.get(`/wp-json/wp/v2/posts?_fields=id,date,link,excerpt,title,content,_embedded,_links&_embed&categories=54&per_page=100&lang=${languagePrexif}`, restParams);
}